import React, { FC } from 'react'

import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import RebateProgram from '../RebateProgram'
import * as Styled from './styled'

export interface RebateProgramSectionProps {
  settings: PractitionerSettings
}

const RebateProgramSection: FC<RebateProgramSectionProps> = ({ settings }) => {
  const isEligibleForRebates = !settings?.practitioner?.ineligibleForRebate

  return (
    <div>
      <h3 className="small-h3">Rebates</h3>
      <Styled.Description>
        Earn rebate dollars on every purchase you make. Your earnings can be used in our store for
        your future purchases or paid out to you as cash rewards. Program rules apply.
      </Styled.Description>
      <RebateProgram settings={settings}>
        <Styled.Label disabled={!isEligibleForRebates}>Rebate Program</Styled.Label>
      </RebateProgram>
      {!isEligibleForRebates && (
        <Styled.IneligibleText>
          Your account is ineligible for Rebates program.
        </Styled.IneligibleText>
      )}
    </div>
  )
}

export default RebateProgramSection
